<template>
     <v-upload-field
        :name="name"
        :label="label"
        :readonly="readonly"
        @input="handleInput"
    />
</template>

<script>
    import axios from 'axios'
    import field from '../../Mixins/field'

    export default {
        mixins: ['file'],
        props: {
            name: {},
            label: {},
            readonly: {
                default: false
            }
        },
        computed: {
            method() {
                return (this.input) ? 'PUT' : 'POST'
            },
            endpoint() {
                return (this.input) ? '/files/' + this.input : '/files'
            }
        },
        methods: {
            async handleInput(path) {
                let {data: file} = await axios({
                    method: this.method,
                    url: this.endpoint,
                    data: {path}
                })
                this.input = file.id
                this.$emit('input', file.id)
            }
        }
    }
</script>